const doc = [({"titleOwnConsumption":"Zusammensetzung Ihres persönlichen Konsums", "titleSwitzerland":"Zusammensetzung in der Schweiz", "titleClosestCountry":"Zusammensetzung {country}"})];
module.exports = doc.length <= 1 ? doc[0] : doc;